export class NativeStreamDedupConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ttlHours",
            "baseName": "ttlHours",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamDedupConfig.attributeTypeMap;
    }
    constructor() {
    }
}
